import { searchWithDiacritics } from '@/helpers/searchWithDiacritics';

export const clientCompanyFilterMixin = {
  data() {
    return {
      filteredClientCompanies: [],
    };
  },
  watch: {
    clientCompanies: {
      immediate: true,
      handler() {
        this.filteredClientCompanies = this.clientCompanies;
      },
    },
  },
  methods: {
    clientCompaniesFilterMethod(query) {
      this.filteredClientCompanies = searchWithDiacritics(query, this.clientCompanies, ['name']);
    },
    handleClientCompaniesVisibleChange() {
      setTimeout(() => {
        this.filteredClientCompanies = this.clientCompanies;
      }, 50);
    },
  },
};
